import(/* webpackMode: "eager" */ "/vercel/path0/apps/superapp/src/app/(internal)/protocol/[slug]/insights/page.tsx");
